(function() {
  // Find the header section-group that actually pins to the top (position:sticky/fixed).
  // Horizon's announcement bar is a separate, non-sticky group, so --header-height
  // (which measures something larger) does NOT equal the real stuck-header bottom.
  // We measure the real pinned group and publish its stuck-bottom as
  // --collection-sticky-top, which the breadcrumb + mobile filter bar stick to.
  function findStickyHeaderGroup() {
    var groups = document.querySelectorAll('[class*="section-group"]');
    var stuck = null;
    groups.forEach(function(g) {
      var p = getComputedStyle(g).position;
      if (p === 'sticky' || p === 'fixed') stuck = g;
    });
    return stuck;
  }

  function init() {
    var headerGroup = findStickyHeaderGroup();
    var headerTopOffset = 0;
    if (headerGroup) {
      headerTopOffset = parseFloat(getComputedStyle(headerGroup).top) || 0; // usually -1px
    }

    function syncOffset() {
      if (!headerGroup) headerGroup = findStickyHeaderGroup();
      if (!headerGroup) return 73;
      var h = headerGroup.getBoundingClientRect().height;
      var offset = Math.round(h + headerTopOffset); // stuck bottom (h plus the -1px tuck)
      if (offset > 0) {
        document.body.style.setProperty('--collection-sticky-top', offset + 'px');
      }
      return offset;
    }

    syncOffset();
    window.addEventListener('resize', syncOffset, { passive: true });
    // header height settles after webfonts/images load
    setTimeout(syncOffset, 400);
    setTimeout(syncOffset, 1500);

    var bg = document.querySelector('.collection-breadcrumb-bg');
    var wrap = document.querySelector('.section-collection-breadcrumb');
    if (!bg || !wrap) return;

    var lastStuck = null;

    function setStuck(s) {
      if (s === lastStuck) return;
      lastStuck = s;
      if (s) {
        bg.style.padding = '8px 0';
        bg.style.background = 'rgba(249, 245, 241, 0.96)';
        bg.style.backdropFilter = 'blur(6px)';
        bg.style.webkitBackdropFilter = 'blur(6px)';
        bg.style.boxShadow = '0 2px 6px rgba(127, 67, 67, 0.18)';
        bg.classList.add('is-stuck');
      } else {
        bg.style.padding = '';
        bg.style.background = '';
        bg.style.backdropFilter = '';
        bg.style.webkitBackdropFilter = '';
        bg.style.boxShadow = '';
        bg.classList.remove('is-stuck');
      }
    }

    function check() {
      // On mobile the breadcrumb is not sticky (filter bar owns the top zone),
      // so never apply the stuck treatment there.
      if (window.innerWidth < 750) {
        setStuck(false);
        return;
      }
      syncOffset();
      var off = parseFloat(getComputedStyle(document.body).getPropertyValue('--collection-sticky-top')) || 73;
      setStuck(wrap.getBoundingClientRect().top <= off + 1);
    }

    // Belt + suspenders: scroll listener + rAF poll.
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() { check(); ticking = false; });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    function tick() {
      check();
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);

    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
